export function getCustomerData (previewOrderData) {
  if (!previewOrderData) return {}

  const customerData = previewOrderData.customerData
  const useAddress = previewOrderData.useAddress
  const isInvoice = previewOrderData.invoiceType === 'invoice'
  const billingCountry = useAddress === '1' ? customerData.country : null
  const shippingCountry = useAddress === '0' ? customerData.sendto_country : null

  return { customerData, useAddress, isInvoice, billingCountry, shippingCountry }
}
